import { Span, InfoTooltip } from "@goodfill/ui-components";

export const OrderValueInfoHorizontal = ({
  label,
  children,
  tooltip,
}: { label: React.ReactNode; children: React.ReactNode; tooltip: string }) => {
  return (
    <div className="flex flex-col my-2 justify-start gap-1">
      <div className="flex w-28">
        <Span font="medium" size="sm" className="offer-label-font px-0-important">
          <InfoTooltip text={tooltip} />
          {label}
        </Span>
      </div>
      <div className="flex flex-col justify-end ml-6 w-[120px]">
        <Span font="medium" size="sm" className="offer-value-font px-0-important">
          {children}
        </Span>
      </div>
    </div>
  );
};
